import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexModule, FlexLayoutModule } from "@ngbracket/ngx-layout";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";

import { IgxGridModule, IgxInputGroupModule, IgxActionStripModule, IgxDropDownModule, IgxCheckboxModule, IgxForOfModule, IgxIconModule } from "@infragistics/igniteui-angular";

import { ForgeModule } from "@tylertech/forge-angular";
import { CommandsModule } from "@tylertech/commands-module";
import { CoreModule } from "@tylertech/core-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { IntentsModule } from "@tylertech/intents-module";
import { AttachmentsModule } from "@tylertech/attachments-module";
import { OdataModule } from "@tylertech/odata-module";
import { MetadataModule } from "@tylertech/metadata-module";
import { AdvancedComponentsModule } from "@tylertech/advanced-components-module";

import { EditDialogComponent, GridRowActionsComponent, InfoTableCardComponent, InfoTableDialogComponent, InfoTableComponent, } from "./components";
import { InfoTableDialogService, InfoTableService, } from "./services";

const angularModules = [
    BrowserModule,
    CommonModule,
    FlexLayoutModule,
    FlexModule,
    FormsModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
];

const lgdModules = [
    CommandsModule,
    CoreModule,
    CommonComponentsModule,
    AttachmentsModule,
    IntentsModule,
    AdvancedComponentsModule,
    OdataModule,
    MetadataModule,
];

const exportedComponents = [
    InfoTableCardComponent,
    InfoTableComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules,
        ForgeModule,
        IgxGridModule,
        IgxInputGroupModule,
        IgxActionStripModule,
        IgxDropDownModule,
        IgxCheckboxModule,
        IgxForOfModule,
        IgxIconModule
    ],
    declarations: [
        ...exportedComponents,
        GridRowActionsComponent,
        InfoTableDialogComponent,
        EditDialogComponent,
    ],
    exports: exportedComponents,
    providers: [
        InfoTableDialogService,
        InfoTableService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InfoTableModule { }
